import React, { useState } from "react";
import { Key } from "../../../../BytebeamClient";
import { useUser } from "../../../../context/User.context";
import { StyledNonBoldHeader } from "../NewAction/NewAction";
import ActionVoidDropdown from "./ActionVoidDropdown";
import SelectableItem from "./SelectableItem";

type ActionDisplayDropdownProps = {
  metadataKeysToShow: string[];
  allowedMetadataKeys: Key[];
  setMetadataKeysToShow: React.Dispatch<React.SetStateAction<string[]>>;
  /**
   * Position of the dropdown relative to the trigger button.
   * @default "right"
   */
  panelPosition?: "left" | "right";
};

const ActionDisplayDropdown: React.FC<ActionDisplayDropdownProps> = ({
  metadataKeysToShow,
  allowedMetadataKeys,
  setMetadataKeysToShow,
  panelPosition = "right",
}) => {
  const { user } = useUser();
  const permissions = user?.role?.permissions;

  const [selectedItemList, setSelectedItemList] = useState<Key[]>(
    metadataKeysToShow.map((val) => ({ key: val }))
  );

  const viewMetadataPermission: "all" | string[] = permissions?.viewMetadata;
  let allowedMetadataKeysMut: Key[] = allowedMetadataKeys;
  allowedMetadataKeysMut = allowedMetadataKeysMut.filter((item) => {
    return (
      item.key !== "id" &&
      (viewMetadataPermission === "all" ||
        viewMetadataPermission.includes(item.key))
    );
  });

  const selectItem = (item: Key) => {
    if (checkItemSelected(item)) {
      // Create a new array without the unselected item
      const filteredArray = selectedItemList.filter(
        (element) => element.key !== item.key
      );
      setSelectedItemList(filteredArray);
      setMetadataKeysToShow(filteredArray.map((item) => item.key));
    } else {
      // Add the selected item to the array by creating a new array
      const newArray = [...selectedItemList, item];
      setSelectedItemList(newArray);
      setMetadataKeysToShow(newArray.map((item) => item.key));
    }
  };

  const checkItemSelected = (item: Key) => {
    return selectedItemList?.some((listItem) => item.key === listItem.key);
  };

  return (
    <ActionVoidDropdown width={"300px"} position={panelPosition}>
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            padding: "1.5rem 1rem",
          }}
        >
          <StyledNonBoldHeader
            as="h3"
            style={{
              marginTop: "0px",
              marginBottom: "1rem",
              fontSize: "1.1rem",
              whiteSpace: "nowrap",
            }}
          >
            Display Properties
          </StyledNonBoldHeader>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "auto auto auto",
              rowGap: "10px",
              columnGap: "10px",
            }}
          >
            {allowedMetadataKeysMut.flatMap((item) => {
              return (
                <SelectableItem
                  key={item.key}
                  title={item.key}
                  selected={checkItemSelected(item)}
                  onClick={() => selectItem(item)}
                />
              );
            })}
          </div>
        </div>
      </div>
    </ActionVoidDropdown>
  );
};

export default ActionDisplayDropdown;
